// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Gj8tF","tabs":"style_tabs__3pV7R","item":"style_item__2zAk8","active":"style_active__1WDV5","box":"style_box__39V9u"};